<template>
  <div class="home">NoAuth</div>
</template>

<script setup lang="ts"></script>
